import {
  Form,
  DatePicker,
  Radio,
  TimePicker,
  Checkbox,
  InputNumber,
} from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";

interface PeriodicitySectionProps {
  isRecurrent: boolean;
  repeatEvery: string | null;
  selectedTime: Dayjs | null;
  form: any;
}

export const PeriodicitySection: React.FC<PeriodicitySectionProps> = ({
  isRecurrent,
  repeatEvery,
  selectedTime,
  form,
}) => {
  const { t } = useTranslation();

  return (
    <div>
      <h3 className="text-base font-semibold mb-2">
        {t("taskHub.modal.periodicity") || ""}
      </h3>
      <div className="grid grid-cols-2 gap-x-4">
        <Form.Item name="is_recurrent" valuePropName="checked">
          <Checkbox>{t("taskHub.modal.enableRecurrence") || ""}</Checkbox>
        </Form.Item>
      </div>

      <div className="grid grid-cols-2 gap-x-4">
        <Form.Item
          name="start_periodicity"
          label={t("taskHub.modal.startDate") || ""}
        >
          <DatePicker
            format="YYYY-MM-DD HH:mm"
            showTime
            style={{ width: "100%" }}
            disabledDate={(date) => date && date.isBefore(dayjs(), "day")}
          />
        </Form.Item>

        {isRecurrent && (
          <>
            <Form.Item
              name="end_periodicity"
              label={t("taskHub.modal.endDate") || ""}
            >
              <DatePicker
                format="YYYY-MM-DD HH:mm"
                showTime
                style={{ width: "100%" }}
                disabledDate={(current) => {
                  const start = form.getFieldValue("start_periodicity");
                  if (!start || !current) return false;
                  return current.isBefore(dayjs(start), "day");
                }}
              />
            </Form.Item>

            <div className="col-span-2">
              <div className="flex items-center gap-2 mb-1">
                <span className="text-sm font-medium">
                  {t("taskHub.modal.repeatEvery") || "Repeat Every"}
                </span>
                <Form.Item name="periodicity_multiple" noStyle>
                  <InputNumber min={1} className="!w-16" />
                </Form.Item>
              </div>
              <Form.Item name="periodicity">
                <Radio.Group className="flex flex-col">
                  <Radio value="daily">{t("taskHub.modal.day") || "Day"}</Radio>
                  <Radio value="weekly">
                    {t("taskHub.modal.week") || "Week"}
                  </Radio>
                  <Radio value="monthly">
                    {t("taskHub.modal.month") || "Month"}
                  </Radio>
                  <Radio value="yearly">
                    {t("taskHub.modal.year") || "Year"}
                  </Radio>
                </Radio.Group>
              </Form.Item>
            </div>
          </>
        )}

        {repeatEvery && (
          <Form.Item name="time" label={t("taskHub.modal.time") || ""}>
            <TimePicker
              format="HH:mm"
              style={{ width: "100%" }}
              value={selectedTime}
            />
          </Form.Item>
        )}
      </div>
    </div>
  );
};
